'use client';
import React from 'react';
import { Div, Text } from '@pezeshk-book/ui-kit';
import { LaboratoryActions } from '@store/lab/lab-actions';
import { useDispatch } from 'react-redux';
import ServiceItem from './sub-components/service-item';
import { useParams } from 'next/navigation';
import getDictionary from '@dictionaries-client';
import { LocaleTypes } from '@dictionaries-types';

const Services = ({ bloodSlug, coronaSlug, labs }: {bloodSlug: string, coronaSlug: string, labs: Array<{slug: string, id: string}>}) => {
  const dispatch = useDispatch();
  const { lang } = useParams<{lang: LocaleTypes}>();
  const { services: { laboratory: { index: { services } } } } = getDictionary(lang);
  const handleSetServiceType = ({ slug } : {slug: string}) => {
    const lab = labs.find(value => value.slug === slug);
    dispatch(LaboratoryActions.setShoppingCartInitialState());
    dispatch(LaboratoryActions.setCityModal({ labId: lab?.id, slug: lab?.slug, open: true }));
  };

  return (
    <Div className={'flex-col md:gap-[72px] gap-8'}>
      <Div className={'w-full flex-col'}>
        <Text color={'grey.800'} typography={'xl'} align={'start'} type={'bold'}>
          {services.title}
        </Text>
        <Text className={'md:mt-10 mt-3'} color={'grey.800'} typography={'base'} align={'justify'}>
          {services.desc_1}
        </Text>
        <Text color={'grey.800'} typography={'base'} align={'start'}>
          {services.desc_2}
        </Text>
        <Text color={'grey.800'} typography={'base'} align={'justify'}>
          {services.desc_3}
        </Text>
        <Text color={'grey.800'} typography={'base'} align={'justify'}>
          {services.desc_4}
        </Text>
      </Div>
      <Div className={'flex-col'}>
        <Text type={'bold'} color={'grey.800'} align={'start'} typography={'xl'}>
          {services.sub_title}
        </Text>
        <Div className={'md:mt-10 mt-6 flex-wrap justify-between gap-2 md:gap-8'}>
          <ServiceItem
            buttonTitle={services.button}
            onClick={() => handleSetServiceType({ slug: coronaSlug })}
            title={services.items.pcr}
            imageUrl={'/images/labs/services/pcr.webp'}
          />
          <ServiceItem
            buttonTitle={services.button}
            onClick={() => handleSetServiceType({ slug: bloodSlug })}
            title={services.items.women_checkup}
            imageUrl={'/images/labs/services/women.webp'}
          />
          <ServiceItem
            buttonTitle={services.button}
            onClick={() => handleSetServiceType({ slug: bloodSlug })}
            title={services.items.children}
            imageUrl={'/images/labs/services/hormun.webp'}
          />
          <ServiceItem
            buttonTitle={services.button}
            onClick={() => handleSetServiceType({ slug: bloodSlug })}
            title={services.items.anti_body}
            imageUrl={'/images/labs/services/antibody.webp'}
          />
          <ServiceItem
            buttonTitle={services.button}
            onClick={() => handleSetServiceType({ slug: bloodSlug })}
            // href={getParseRoute({ pathname: routes['route.labs.show'], query: { id: bloodSlug } })}
            title={services.items.men_checkup}
            imageUrl={'/images/labs/services/men.webp'}
          />
          <ServiceItem
            buttonTitle={services.button}
            onClick={() => handleSetServiceType({ slug: bloodSlug })}
            title={services.items.checkup_before_pregnancy}
            imageUrl={'/images/labs/services/prepregnancy.webp'}
          />
          <ServiceItem
            buttonTitle={services.button}
            onClick={() => handleSetServiceType({ slug: coronaSlug })}
            title={services.items.air_line_pcr}
            imageUrl={'/images/labs/services/airline.webp'}
          />
          <ServiceItem
            buttonTitle={services.button}
            onClick={() => handleSetServiceType({ slug: bloodSlug })}
            title={services.items.hpv}
            imageUrl={'/images/labs/services/hpv.webp'}
          />
        </Div>
      </Div>
    </Div>
  );
};

export default Services;
